// extracted by mini-css-extract-plugin
export default {"itemgroup":"item_itemgroup__uI2Zp"};